import { IAppState } from '../../../AppModulesWrapper';

import { selectIsWithoutTopAndPremium } from '../publishTerms';
import { selectIsPromotionForbidden, selectIsServicesEnabled } from '../../reducers/v2/promotion/selectors';

export const selectIsModuleWithPromotion = (state: IAppState): boolean => {
  const isPromotionForbidden = selectIsPromotionForbidden(state);
  const isWithoutTopAndPremium = selectIsWithoutTopAndPremium(state);
  const isDisabledPromotion = isPromotionForbidden || isWithoutTopAndPremium;

  const isServicesEnabled = selectIsServicesEnabled(state);

  return isDisabledPromotion ? false : isServicesEnabled;
};
